const HI_NOTIFY_PRACTICE = 'HI_NOTIFY_PRACTICE'
const HI_NOTIFY_PRACTICE_RECEIVED = 'HI_NOTIFY_PRACTICE_RECEIVED'
const HI_NOTIFY_PRACTICE_FAILED = 'HI_NOTIFY_PRACTICE_FAILED'
const UPDATE_NEEDS_ATTENTION_TAG_NOTE = 'UPDATE_NEEDS_ATTENTION_TAG_NOTE'
const UPDATE_NEEDS_ATTENTION_TAG_NOTE_RECEIVED = 'UPDATE_NEEDS_ATTENTION_TAG_NOTE_RECEIVED'
const UPDATE_NEEDS_ATTENTION_TAG_NOTE_FAILED = 'UPDATE_NEEDS_ATTENTION_TAG_NOTE_FAILED'

const hiNotifyPractice = payload => ({
  type: HI_NOTIFY_PRACTICE,
  payload
})

const hiNotifyPracticeReceived = payload => ({
  type: HI_NOTIFY_PRACTICE_RECEIVED,
  payload
})

const hiNotifyPracticeFailed = payload => ({
  type: HI_NOTIFY_PRACTICE_FAILED,
  payload
})

const updateNeedsAttentionTagNote = payload => ({
  type: UPDATE_NEEDS_ATTENTION_TAG_NOTE,
  payload
})

const updateNeedsAttentionTagNoteReceived = payload => ({
  type: UPDATE_NEEDS_ATTENTION_TAG_NOTE_RECEIVED,
  payload
})

const updateNeedsAttentionTagNoteFailed = payload => ({
  type: UPDATE_NEEDS_ATTENTION_TAG_NOTE_FAILED,
  payload
})

export default {
  hiNotifyPractice,
  hiNotifyPracticeReceived,
  hiNotifyPracticeFailed,
  HI_NOTIFY_PRACTICE,
  HI_NOTIFY_PRACTICE_RECEIVED,
  HI_NOTIFY_PRACTICE_FAILED,
  updateNeedsAttentionTagNote,
  updateNeedsAttentionTagNoteReceived,
  updateNeedsAttentionTagNoteFailed,
  UPDATE_NEEDS_ATTENTION_TAG_NOTE,
  UPDATE_NEEDS_ATTENTION_TAG_NOTE_RECEIVED,
  UPDATE_NEEDS_ATTENTION_TAG_NOTE_FAILED
}
